import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export function useInvestmentPrice() {
  const [price, setPrice] = useState(250);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'settings', 'investmentPrice'),
      (doc) => {
        if (doc.exists()) {
          setPrice(doc.data().amount);
        }
      },
      (error) => {
        console.error('Erreur lors de la récupération du prix:', error);
      }
    );

    return () => unsubscribe();
  }, []);

  return price;
} 